import React from 'react';
import { IconEllipsis } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
const ParticipantActionEllipsis = ({ accessibilityLabel, onClick, participantID }) => (React.createElement(Button
// accessibilityLabel={accessibilityLabel}
, { 
    // accessibilityLabel={accessibilityLabel}
    icon: IconEllipsis, onClick: onClick, size: 'small', testId: participantID ? `participant-more-options-${participantID}` : undefined, className: 'participantMoreOptions' }));
export default ParticipantActionEllipsis;
